import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/shipin2/icon-search.png';
const _withScopeId = n => (_pushScopeId("data-v-154a1cc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-nav"
};
const _hoisted_2 = {
  class: "search-input"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "left-icon",
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  key: 0,
  class: "pop-div"
};
const _hoisted_5 = {
  class: "notice-header"
};
const _hoisted_6 = {
  class: "notice-title"
};
const _hoisted_7 = {
  class: "notice-content"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发送任意邮件至", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "[重要提示]:强烈推荐使用谷歌浏览器进行访问", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本站最近经常被联通屏蔽域名,请更换(移动或者电信)网络访问", -1));
const _hoisted_11 = {
  key: 0,
  class: "iosdiv"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
}, "IOS - APP轻量版安装", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
}, "IOS - APP标准版安装", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
}, "安卓手机最新APP版本下载", -1));
import { ref, onMounted, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';
import { useIndexStore } from "../store";
import { storeToRefs } from 'pinia';
import { judgeClient, downloadApp } from '@/utils';
export default {
  __name: 'HeaderNav',
  props: {
    list: {}
  },
  emits: ["search", "saveTheUrl"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const userIndex = useIndexStore();
    const {
      config
    } = storeToRefs(userIndex);
    const {
      setKeys
    } = userIndex;
    const route = useRoute();
    const router = useRouter();
    const value = ref("");
    value.value = route.query.keyword;
    const search = () => {
      if (!value.value) {
        return alert("请输入关键词");
      }
      if (route.query.keyword) {
        emit("search", value.value);
      } else {
        router.push({
          path: "/search",
          query: {
            keyword: value.value
          }
        });
      }
    };
    const backHome = () => {
      router.push('/');
    };
    const show = ref(false);
    const saveTheUrl = () => {
      show.value = true;
    };
    const openSaveTheUrl = inject('openSaveTheUrl', () => {});
    openSaveTheUrl.value = saveTheUrl;
    __expose({
      saveTheUrl
    });
    const qrurl = ref('');
    const download = async imgUrl => {
      qrurl.value = await imgUrl;
      setTimeout(() => {
        html2canvas(document.querySelector('#dwqrcode')).then(canvas => {
          const link = document.createElement('a');
          link.download = 'qrcode.png';
          link.href = canvas.toDataURL();
          link.click();
        });
      }, 1000);
    };
    const clickInput = () => {
      setKeys('');
      router.push('search');
    };
    const query = item => {
      setKeys(item);
      router.push({
        path: "search"
      });
    };
    const searchKeys = ["自慰", "极品", "学生", "人妻", "巨乳", "内射", "少女", "高潮", "女神", "少妇", "黑丝", "姐姐", "萝莉", "诱惑", "调教", "颜值", "中出", "美女", "乱伦", "清纯", "口交", "肛交", "口爆", "颜射", "吞精", "尿尿", "捆绑", "内射", "潮吹", "深喉", "偷窥", "自慰", "强奸", "车震", "教室", "大学", "part", "厕所", "酒店", "野外", "club", "商场", "飞机", "浴室", "按摩", "护士", "学生", "老师", "继母", "姐弟", "父女", "情侣", "房东", "邻居", "明星", "麻豆", "SWAG", "萝莉社", "JVID", "星空", "天美"];
    const keys = ref(searchKeys[Math.floor(Math.random() * searchKeys.length)]);
    onMounted(() => {});

    // 判断当前是安卓还是IOS，取渠道后台配置的 下载地址
    const clickDownApp = () => {
      let android_download_urls = [...config.value.android_download_urls.split(',')];
      let ios_download_urls = [...config.value.ios_download_urls.split(',')];
      console.log('android_download_urls', android_download_urls, 'ios_download_urls', ios_download_urls);
      downloadApp(ios_download_urls, android_download_urls);
    };
    const clickgotoIOSBookmark = () => {
      window.location.href = config.value.bookmark_url || config.value.ios_download_urls;
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
        class: "img",
        fit: "cover",
        src: _unref(config).h5_logo,
        onClick: backHome
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        placeholder: "大家都在搜...",
        onSearch: search,
        readonly: "",
        onClickInput: clickInput
      }, {
        "left-icon": _withCtx(() => [_hoisted_3]),
        "right-icon": _withCtx(() => [_createElementVNode("div", {
          class: "key-btn",
          onClick: _cache[0] || (_cache[0] = $event => query(keys.value))
        }, _toDisplayString(keys.value), 1)]),
        _: 1
      }), _createElementVNode("div", {
        class: "save-the-url",
        onClick: saveTheUrl
      }, "保存网址")]), _createVNode(_component_van_popup, {
        teleport: "#app",
        class: "pop-notice",
        "z-index": "1000",
        show: show.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => show.value = $event),
        round: "",
        "close-on-click-overlay": false,
        style: {
          width: '80%',
          'background': 'none'
        }
      }, {
        default: _withCtx(() => [_createVNode(_Transition, {
          name: "animate__animated animate__zoomOut",
          "enter-active-class": "animate__zoomIn",
          "leave-active-class": "animate__zoomOut"
        }, {
          default: _withCtx(() => [show.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_unref(config).logo_title), 1), _createTextVNode(" · 最新公告 ")]), _createElementVNode("div", {
            class: "popup-close-icon-div",
            onClick: _cache[1] || (_cache[1] = $event => show.value = false)
          }, [_createVNode(_component_van_icon, {
            name: "cross",
            class: "popup-close-icon"
          })])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("div", {
            class: "qrcode",
            onClick: download
          }, [_createVNode(_component_van_image, {
            src: "https://ennque82lq.dsssdf06.com/vstore91/upload/20240719/557f6e87be6f03fdfc0eacea0f551be3.png"
          })]), _createElementVNode("p", null, _toDisplayString(_unref(config).logo_title) + "最新域名", 1), _createElementVNode("p", null, [_createElementVNode("b", null, _toDisplayString(_unref(config).website && _unref(config).website.replaceAll('https://', '').replaceAll('http://', '')), 1)]), _hoisted_8, _createElementVNode("p", null, "秒得最新地址 " + _toDisplayString(_unref(config).email), 1), _hoisted_9, _hoisted_10])]), _unref(judgeClient)() === 'IOS' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
            class: "appdownB iosbg",
            onClick: clickgotoIOSBookmark
          }, [_createVNode(_component_van_image, {
            src: require('../assets/logo-ios2.png')
          }, null, 8, ["src"]), _hoisted_12]), _createElementVNode("div", {
            class: "appdownB",
            onClick: clickDownApp
          }, [_createVNode(_component_van_image, {
            src: require('../assets/logo-ios.png')
          }, null, 8, ["src"]), _hoisted_13])])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "appdownB",
            onClick: clickDownApp
          }, [_createVNode(_component_van_image, {
            src: require('../assets/logo-android.png')
          }, null, 8, ["src"]), _hoisted_14]))])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};